import { useSnackbarStore } from '../stores/snackbar';
export default {
    install(app) {
        // Tambahkan $snackbar ke semua instance Vue
        app.config.globalProperties.$snackbar = useSnackbarStore();
    },
};
